import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { message: String }

  requestAndClose(event) {
    if (event) event.preventDefault()

    const dialogElement = this.element.closest("[data-controller~=\"dialog\"]") || this.element.closest("dialog")

    if (!dialogElement) {
      this.openIntercom()
      return
    }

    const onDismiss = () => {
      dialogElement.removeEventListener("dialog:dismiss", onDismiss)
      this.openIntercom()
    }

    dialogElement.addEventListener("dialog:dismiss", onDismiss, { once: true })

    const dialogController = this.application.getControllerForElementAndIdentifier(dialogElement, "dialog")
    if (dialogController) {
      dialogController.close()
    } else {
      dialogElement.removeEventListener("dialog:dismiss", onDismiss)
      this.openIntercom()
    }
  }

  openIntercom = () => {
    if (window.Intercom) {
      if (this.hasMessageValue) {
        window.Intercom("showNewMessage", this.messageValue)
      } else {
        window.Intercom("show")
      }
    } else {
      const launcher = document.querySelector(".button--open-intercom-chat")
      if (launcher) launcher.click()
    }
  }
}


